import { useEffect, useRef, useState } from 'react';

/**
 * Slika s strežnika z žetonom (img ga ne pošlje), zato kot blob URL; {@code kljuc} določi, kdaj se naloži znova
 * ({@code null} = brez slike). {@code nalozi} je klic {@code api.GET(..., { parseAs: 'blob', signal })}.
 */
export function useSlikaApi(
  kljuc: string | null,
  nalozi: (signal: AbortSignal) => Promise<{ data?: unknown; response: Response }>,
): string | null {
  const [url, setUrl] = useState<string | null>(null);
  const klic = useRef(nalozi);
  useEffect(() => {
    klic.current = nalozi;
  });
  useEffect(() => {
    if (!kljuc) {
      return;
    }
    let naslov: string | null = null;
    const prekini = new AbortController();
    void klic
      .current(prekini.signal)
      .then(({ data, response }) => {
        if (response.ok && data instanceof Blob) {
          naslov = URL.createObjectURL(data);
          setUrl(naslov);
        }
      })
      .catch(() => undefined);
    return () => {
      prekini.abort();
      if (naslov) {
        URL.revokeObjectURL(naslov);
      }
      setUrl(null);
    };
  }, [kljuc]);
  return url;
}
